import { ITkFakeTableLineProps } from "../../type/componentsType/TkFakeTableLine";
import TkPropertyMessageGet from "../../utils/TkPropertyMessageGet";

const monthMapping = {
  apr: "4",
  may: "5",
  jun: "6",
  jul: "7",
  aug: "8",
  sep: "9",
  oct: "10",
  nov: "11",
  dec: "12",
  jan: "1",
  feb: "2",
  mar: "3",
} as any;

const infoHeadTitleList = [
  {
    headTitle: "出生日",
  },
  {
    headTitle: "育児休業開始日",
  },
  {
    headTitle: "育児休業終了日",
  },
  {
    headTitle: "パパママ育休プラス",
  },
  {
    headTitle: "産後パパ育休",
  },
  {
    headTitle: "半年延長の理由",
  },
];

const headList = [
  {
    headTitle: "担当者",
  },
  {
    headTitle: "処理",
  },
  {
    headTitle: "実施日",
  },
  {
    headTitle: "コメント",
  },
];

const fakeTableList: ITkFakeTableLineProps[] = [
  {
    title: "契約者番号",
    keyword: "contractorNo",
    type: "text",
  },
  {
    title: "契約者名",
    keyword: "corpName",
    type: "text",
  },
  {
    title: "契約者住所",
    keyword: "corpAddress",
    type: "text",
  },
  {
    title: "TEL",
    keyword: "tel",
    type: "text",
  },
  {
    title: "FAX",
    keyword: "fax",
    type: "text",
  },
  {
    title: "施設番号",
    keyword: "facilityNo",
    type: "text",
  },
  {
    title: "施設名",
    keyword: "facilityName",
    type: "text",
  },
  {
    title: "施設住所",
    keyword: "facilityAddress",
    type: "text",
  },
  {
    title: "施設種類",
    keyword: "facilityKind",
    type: "text",
  },
  {
    title: "施設区分",
    keyword: "facilityKbn",
    type: "text",
  },
  {
    title: "職員番号",
    keyword: "staffNo",
    type: "text",
  },
  {
    title: "職員名",
    keyword: "staffNameKanji",
    type: "text",
  },
  {
    title: "性別",
    keyword: "sex",
    type: "text",
  },
  {
    title: "職種",
    keyword: "jobName",
    type: "text",
  },
  {
    title: "生年月日",
    keyword: "birthday",
    type: "text",
  },
  {
    title: "加入日",
    keyword: "joinDate",
    type: "date",
    requiredIcon: true,
    maxDate: new Date(),
    minDate: new Date("1900/01/01"),
  },
  {
    title: "退職日",
    keyword: "retireDate",
    type: "text",
  },
  {
    title: "俸給表の額",
    keyword: "salaryTableAmt",
    type: "text",
  },
  {
    title: "俸給の調整額",
    keyword: "salaryAdjustmentAmt",
    type: "text",
  },
  {
    title: "合計",
    keyword: "sun",
    type: "text",
  },
  {
    title: "退職届提出日",
    keyword: "applyDate",
    type: "text",
  },
  {
    title: "支給額",
    keyword: "paymentAmt",
    type: "text",
  },
  {
    title: "送金予定日",
    keyword: "remitDueDate",
    type: "text",
  },
  {
    title: "ならない月",
    keyword: "unrecognizedMonthList",
    type: "nodeInLine",
  },
  {
    keyword: "childcareLeaveList",
    type: "node",
  },
  {
    keyword: "memo",
    type: "node",
    showLine: false,
  },
];

const schema: any = {
  memo: {
    maxLength: {
      value: 500,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "500"),
    },
  },
  joinDate: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
  },
};

export { monthMapping, fakeTableList, infoHeadTitleList, headList, schema };
